module.exports = __webpack_public_path__ + "img/NO982719445.79bc2c91.png";